// extracted by mini-css-extract-plugin
export var userArea = "ourUser-module--userArea--761fa";
export var userArea__item = "ourUser-module--userArea__item--f1e5c";
export var userArea__list = "ourUser-module--userArea__list--4f75f";